export default __webpack_public_path__ + "static/1-e55434b97942f1ac907c69d2e8ad2854.png";